import { CreditCardIcon } from "@heroicons/react/16/solid";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { useState } from "react";

import type { ProjectRevenueQuota } from "~/modules/project/api/projectRevenueReport/projectRevenueReportTypes.ts";
import {
	ProjectRevenueQuotaCard,
} from "~/modules/project/components/ProjectDetailsView/components/ProjectRevenueReportSection/components/ProjectRevenueQuotaSection/components/ProjectRevenueQuotaCard/ProjectRevenueQuotaCard.tsx";
import { getQuotaConsumedCents } from "~/modules/project/components/ProjectDetailsView/components/ProjectRevenueReportSection/projectRevenueReportUtils.ts";
import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";

type Props = {
	quotas: ProjectRevenueQuota[];
	projectId: string;
};

// The quotas that serve this project, collapsed by default to one summary line.
export const ProjectRevenueQuotaSection = ({ quotas, projectId }: Props) => {
	const [isOpen, setIsOpen] = useState(false);

	const consumerCount = quotas.reduce((count, quota) => count + quota.consumers.length, 0);
	const consumedCents = quotas.reduce((sum, quota) => sum + getQuotaConsumedCents(quota), 0);

	return <div className="rounded-lg bg-white shadow">
		<button type="button"
				onClick={() => setIsOpen(!isOpen)}
				className="flex w-full items-center gap-x-3 rounded-lg px-4 py-2 text-left text-sm hover:bg-gray-50">
			{isOpen ? <ChevronDownIcon className="size-4" /> : <ChevronRightIcon className="size-4" />}
			<CreditCardIcon className="size-4 text-gray-400" />
			<span className="font-semibold text-gray-800">Verwendete Kontingente</span>
			<span className="text-gray-500">
				{quotas.length === 1 ? "1 Kontingent" : `${quotas.length} Kontingente`}
				{" · "}
				{consumerCount === 1 ? "1 Bestellung" : `${consumerCount} Bestellungen`}
			</span>
			<span className="ml-auto text-gray-500">
				verfügtes Budget <span className="font-semibold text-gray-900">{formatCentsToCurrency(consumedCents)}</span>
			</span>
		</button>
		{isOpen && <div className="grid grid-cols-[repeat(auto-fill,minmax(24rem,1fr))] gap-3 border-t border-gray-100 p-4">
			{quotas.map((quota) => <ProjectRevenueQuotaCard key={quota.quotaId}
															quota={quota}
															projectId={projectId} />)}
		</div>}
	</div>;
};
